/**
 * Extracts all unique name properties from a nested data structure recursively.
 *
 * This function traverses through objects and arrays to find all string-valued 'name'
 * properties, excluding those where the object has type "LABEL". It also skips traversing
 * into certain object properties ('inputParameters', 'subWorkflowParam', 'startWorkflow').
 *
 * @param {Object|Array} data - The data structure to extract names from
 * @returns {Array<string>} - Array of unique name values found in the data structure
 */
export function extractNamesRecursively(data) {
  const names = new Set();

  function traverse(item) {
    if (!item || (typeof item !== "object" && !Array.isArray(item))) {
      return;
    }

    if (Array.isArray(item)) {
      item.forEach(traverse);
    } else {
      if (
        "name" in item &&
        typeof item.name === "string" &&
        item.type !== "LABEL"
      ) {
        names.add(item.name);
      }

      for (const key in item) {
        if (Object.prototype.hasOwnProperty.call(item, key)) {
          if (
            ["inputParameters", "subWorkflowParam", "startWorkflow"].includes(
              key
            )
          )
            continue;
          traverse(item[key]);
        }
      }
    }
  }

  traverse(data);
  return Array.from(names);
}
